import { h } from 'preact';
import { i18n, Utils } from '@/base/helpers';
import './styles/ActionModalBody.css';

const ActionModalBody = ({
  actionStatus,
  socialUsername,
  message,
  loading,
  onChange,
  onUsernameSave,
  onUsernameEdit,
  onRuleActionVerify,
  actionRule,
  socialPlatform,
  socialPlatformLogoSVG,
  onClose,
  verificationStatus,
}) => {
  const disabledStyle = loading ? { opacity: 0.8, cursor: 'wait' } : {};

  const renderAuthRequired = () => (
    <div className="liana-modal-body-content-wrapper">
      <div className="beans-text">{actionRule.settings.statement}</div>
      <div className="liana-action-modal-input-wrapper">
        <div className="beans-small beans-text-bold beans-text-secondary">
          {i18n.t('rules', 'enter_social_username', { social_platform: socialPlatform })}
        </div>
        <input type="text" value={socialUsername} onChange={onChange} id="liana-modal-username-input" required />
        {message.text && (
          <div className="beans-text" style={{ color: message.color }}>
            {message.text}
          </div>
        )}
      </div>
      <div
        className="beans-button beans-button-primary"
        role="button"
        tabIndex={0}
        onClick={!loading ? onUsernameSave : null}
        style={disabledStyle}
      >
        {i18n.t('settings', 'save')}
      </div>
    </div>
  );

  const renderActionRequired = () => (
    <div className="liana-modal-body-content-wrapper">
      <div className="liana-social-username-preview-block">
        <div className="liana-social-username-preview">
          {socialPlatformLogoSVG}
          <div>
            <div className="beans-small">Profile username:</div>
            <div className="beans-text beans-text-bold">{socialUsername}</div>
          </div>
        </div>
        <div
          className="beans-button beans-button-inline"
          style={disabledStyle}
          onClick={!loading ? onUsernameEdit : null}
          tabIndex={0}
          role="button"
        >
          {i18n.t('rules', 'edit')}
        </div>
      </div>

      {/* <div className="beans-text">{actionRule.settings.statement}</div> */}

      <div className="liana-social-action-steps">
        <div className="beans-text">
          1.{' '}
          <span
            className="beans-button beans-button-inline"
            onClick={() => Utils.handleRuleActionCTAClick(actionRule)}
            tabIndex={0}
            role="link"
          >
            {i18n.t('rules', 'follow_us_on', { social_platform: socialPlatform })}
          </span>
        </div>
        <div className="beans-text">2. {i18n.t('rules', 'get_reward')}</div>
        {/* {message.text && (
          <div className="beans-text" style={{ color: message.color }}>
            {message.text}
          </div>
        )} */}
      </div>

      <div
        className="beans-button beans-button-primary"
        role="button"
        tabIndex={0}
        style={disabledStyle}
        onClick={!loading ? onRuleActionVerify : null}
      >
        {i18n.t('rules', 'get_points')}
      </div>
    </div>
  );

  const renderVerificationMessage = () => (
    <div className="liana-modal-body-content-wrapper">
      <div className="liana-modal-verification-message-wrapper">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15.114" cy="14.9324" r="14.4792" fill="#31AE5C" />
          <path d="M9.29358 15.2751L13.7879 19.7693L21.3766 12.1807" stroke="white" strokeWidth="3.30318" />
        </svg>

        <div className="beans-text">
          {i18n.t('rules', 'verification')}
          <span className="liana-animated-dots" />
        </div>
      </div>
      <div className="beans-text beans-text">
        * This process can take up to 10 minutes. You will receive your points once it is completed.
      </div>
      <div className="beans-button beans-button-secondary" role="button" tabIndex={0} onClick={onClose}>
        Close
      </div>
    </div>
  );

  return (
    <div className="liana-action-modal-body">
      {!verificationStatus && actionStatus === 'auth_required' && renderAuthRequired()}
      {!verificationStatus && actionStatus === 'action_required' && renderActionRequired()}
      {verificationStatus && renderVerificationMessage()}
    </div>
  );
};

export default ActionModalBody;
